import { buttonStyle } from 'components/buttons/buttonStyle';
import { Button } from 'components/ui/button';
import EmploymentModal from 'components/modals/employment/EmploymentModal';
import { ModalActions } from 'components/modals/useModal';
import { FormattedMessage } from 'react-intl';
import { EmploymentForm } from 'types/employees';
import { NamedEntityMinDto } from 'types/other';

interface Props {
    readonly?: boolean;
    employment: EmploymentForm;
    jobRoleList: NamedEntityMinDto[];
    jobPositionList: NamedEntityMinDto[];
    onSave?: (data: EmploymentForm) => void;
    onDelete?: (recordId: number) => void;
    modalActions: ModalActions;
}

export function EmploymentUnit({
    employment,
    readonly,
    jobPositionList,
    jobRoleList,
    onSave,
    onDelete,
    modalActions,
}: Props) {
    const openEmploymentModal = () =>
        modalActions.openModal(
            <EmploymentModal
                onClose={modalActions.closeModal}
                onDelete={onDelete}
                onSave={onSave}
                initialData={employment}
                titleId={'employees.employment.form.edit'}
                jobRoleList={jobRoleList}
                jobPositionList={jobPositionList}
            />
        );

    const fromDate = employment.validFrom ? `From ${employment.validFrom}` : '';
    const toDate = employment.validTo ? ` to ${employment.validTo}` : '';
    const jobRoleJobPosition = [employment.jobRole?.name, employment.jobPosition?.name].join(', ');
    const officeCoreTeam = [employment.office?.name, employment.coreTeam?.name].join(' | ');

    return (
        <div className="group flex gap-3">
            <div className="flex flex-col items-center">
                <div className="bg-grey-300 h-2 w-px group-first:invisible" />
                <div className="bg-primary size-2.5 shrink-0 rounded-full" />
                <div className="bg-grey-300 w-px grow group-last:invisible" />
            </div>
            <div className="flex flex-1 items-center justify-between pr-2.5 pb-4 group-last:pb-0">
                <div className="flex flex-col">
                    <strong>{jobRoleJobPosition}</strong>
                    {fromDate + toDate}
                    <span className="text-fg-secondary">{officeCoreTeam}</span>
                </div>
                {!readonly && (
                    <Button {...buttonStyle({ variant: 'outlined', size: 'extraSmall' })} onClick={openEmploymentModal}>
                        <FormattedMessage id="edit" />
                    </Button>
                )}
            </div>
        </div>
    );
}
